import { render, staticRenderFns } from "./RootNodeConfig.vue?vue&type=template&id=d062dd44&scoped=true"
import script from "./RootNodeConfig.vue?vue&type=script&lang=js"
export * from "./RootNodeConfig.vue?vue&type=script&lang=js"
import style0 from "./RootNodeConfig.vue?vue&type=style&index=0&id=d062dd44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d062dd44",
  null
  
)

export default component.exports